/* Responsive editorial controls. All content remains readable without JavaScript. */
class RsScrollableProgress extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.track = this.querySelector('.rs-categories__grid, .rs-campaign__promo-track');
    this.bar = this.querySelector('.rs-category-progress, .rs-promo-progress');
    if (!this.track || !this.bar) return;
    this.update = () => {
      const width = this.track.clientWidth;
      const distance = this.track.scrollWidth - width;
      this.bar.hidden = distance < 2;
      const thumb = this.bar.firstElementChild;
      const ratio = Math.min(1, width / (this.track.scrollWidth || width || 1));
      const progress = distance > 0 ? Math.min(1, Math.abs(this.track.scrollLeft) / distance) : 0;
      thumb.style.width = `${ratio * 100}%`;
      thumb.style.marginInlineStart = `${progress * (1 - ratio) * 100}%`;
    };
    this.track.addEventListener('scroll', this.update, { passive: true, signal: this.controller.signal });
    this.observer?.disconnect();
    this.observer = new ResizeObserver(this.update);
    this.observer.observe(this.track);
    this.update();
  }
  disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
}
if (!customElements.get('rs-category-rail')) customElements.define('rs-category-rail', class extends RsScrollableProgress {});
if (!customElements.get('rs-promo-rail')) customElements.define('rs-promo-rail', class extends RsScrollableProgress {});
if (!customElements.get('rs-journal-feed')) customElements.define('rs-journal-feed', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    this.articles = [...this.querySelectorAll('.rs-journal__article')];
    this.button = this.querySelector('.rs-journal__more');
    this.breakpoint = matchMedia('(max-width: 749px)');
    this.expanded = false;
    this.update = () => {
      const collapse = this.breakpoint.matches && !this.expanded;
      this.articles.forEach((article, index) => { article.hidden = collapse && index > 0; });
      if (this.button) {
        this.button.hidden = !this.breakpoint.matches || this.expanded || this.articles.length < 2;
        this.button.setAttribute('aria-expanded', String(this.expanded));
      }
    };
    this.button?.addEventListener('click', () => {
      this.expanded = true; this.update();
      const firstNew = this.articles[1];
      if (firstNew) { firstNew.tabIndex = -1; firstNew.focus({ preventScroll: true }); }
    }, { signal: this.controller.signal });
    this.breakpoint.addEventListener('change', this.update, { signal: this.controller.signal });
    this.update();
  }
  disconnectedCallback() { this.controller?.abort(); }
});
if (!customElements.get('rs-review-navigation')) customElements.define('rs-review-navigation', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    this.review = this.closest('rs-testimonials');
    const tabs = [...(this.review?.querySelectorAll('[role="tab"]') || [])];
    this.hidden = tabs.length < 2;
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-review-direction]');
      if (!button || tabs.length < 2) return;
      const current = tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true');
      const direction = Number(button.dataset.reviewDirection);
      const next = tabs[(Math.max(0, current) + direction + tabs.length) % tabs.length];
      /* Existing rs-testimonials handles the actual tab/panel state. */
      next.click();
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
});
